module.exports = require("sprintf-js");